import { useState, useEffect } from 'react';
import { getToken } from '@shared/services/api';
import { DashboardSummary } from '../types';

export function useDashboardSummary(timePeriod: string) {
  const [dashboardData, setDashboardData] = useState<DashboardSummary | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      setError(null);
      try {
        const token = getToken();
        if (!token) {
          throw new Error('No authentication token found.');
        }
        const response = await fetch(`/api/v1/dashboard/summary?time_period=${timePeriod}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error('Failed to fetch dashboard data.');
        }
        const data = await response.json();
        setDashboardData(data);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [timePeriod]);

  return {
    dashboardData,
    loading,
    error,
    setDashboardView: (dashboardView: string) => {
      setDashboardData((current) =>
        current ? { ...current, dashboard_view: dashboardView } : current
      );
    },
  };
}
